import { UIClassesSpec } from './types';

export interface UISVGContent {
    root: SVGElement;
}

export class UISVG {
    ui_elem: SVGSVGElement;
    root: SVGSVGElement;

    constructor(classes?: UIClassesSpec, viewport?: [number, number]) {
        this.ui_elem = this.root = $svg.newElem('svg', classes) as SVGSVGElement;
        if(viewport)
            this.root.setAttribute('viewBox', `0 0 ${viewport[0]} ${viewport[1]}`);
    }

    add(el: SVGElement) {
        this.root.appendChild(el);
    }

    remove() {
        this.root.remove();
    }

    get classList() {
        return this.root.classList;
    }

    linearGradient(start: string, end: string) {
        const id = $svg.newId();
        const lg = $svg.newElem('linearGradient') as SVGLinearGradientElement;
        lg.id = id;
        lg.setAttribute('x1', '0');
        lg.setAttribute('x2', '0');
        lg.setAttribute('y1', '0');
        lg.setAttribute('y2', '100%');
        lg.setAttribute('gradientUnits', 'userSpaceOnUse');
        lg.appendChild($svg.STOP(start, 0));
        lg.appendChild($svg.STOP(end, 1));
        this.root.appendChild(lg);
        return 'url("#' + id + '")';
    }
}

export namespace $svg {
    let svg_id = 0;

    export function newId() {
        return 'y_svg_' + (++svg_id);
    }

    function joinClasses(classes: (UIClassesSpec | undefined | false)[]) {
        let join = '';

        for(const c of classes) {
            if(c) {
                if(typeof c === 'string') {
                    join += ' ';
                    join += c;
                } else {
                    join += joinClasses(c);
                }
            }
        }

        return join;
    }

    export function newElem<K extends keyof SVGElementTagNameMap>(tag: K, classes?: UIClassesSpec): SVGElementTagNameMap[K];
    export function newElem(tag: string, classes?: UIClassesSpec): SVGElement;
    export function newElem(tag: string, classes?: UIClassesSpec) {
        const elem = document.createElementNS('http://www.w3.org/2000/svg', tag);

        if(classes) {
            if(typeof classes === 'string') {
                elem.setAttribute('class', classes);
            } else {
                const join = joinClasses(classes);
                if(join)
                    elem.setAttribute('class', join.substring(1));
            }
        }

        return elem;
    }

    export function PATH(classes?: UIClassesSpec, d?: string) {
        const elem = newElem('path', classes);
        if(d)
            elem.setAttribute('d', d);
        return elem;
    }

    export function G(classes?: UIClassesSpec) {
        return newElem('g', classes);
    }


    export function TEXT(text?: string, classes?: UIClassesSpec, x?: number, y?: number, dx?: string, dy?: string): SVGTextElement {
        const elem = newElem('text', classes);
        if(text)
            elem.textContent = text;
        if(x)
            elem.setAttribute('x', x as any);
        if(y)
            elem.setAttribute('y', y as any);
        if(dx)
            elem.setAttribute('dx', dx);
        if(dy)
            elem.setAttribute('dy', dy);
        return elem;
    }

    export function CIRCLE(cx: number, cy: number, r: number, classes?: UIClassesSpec): SVGCircleElement {
        const circle = newElem('circle', classes);
        circle.setAttribute('cx', cx as any);
        circle.setAttribute('cy', cy as any);
        circle.setAttribute('r', r as any);
        return circle;
    }

    export function LINE(x1: number | string, y1: number | string, x2: number | string, y2: number | string, classes?: UIClassesSpec): SVGLineElement {
        const line = newElem('line', classes);
        line.setAttribute('x1', x1 as any);
        line.setAttribute('y1', y1 as any);
        line.setAttribute('x2', x2 as any);
        line.setAttribute('y2', y2 as any);
        return line;
    }

    export function RECT(x: number, y: number, w: number, h: number, classes?: UIClassesSpec): SVGRectElement {
        const rect = newElem('rect', classes);
        rect.setAttribute('x', x as any);
        rect.setAttribute('y', y as any);
        rect.setAttribute('width', w as any);
        rect.setAttribute('height', h as any);
        return rect;
    }

    export function ROUNDEDRECT(x: number, y: number, w: number, h: number, rx: number, ry: number, classes?: UIClassesSpec): SVGRectElement {
        const rect = newElem('rect', classes);
        rect.setAttribute('x', x as any);
        rect.setAttribute('y', y as any);
        rect.setAttribute('rx', rx as any);
        rect.setAttribute('ry', ry as any);
        rect.setAttribute('width', w as any);
        rect.setAttribute('height', h as any);
        return rect;
    }

    export function POLYGON(points: string | number[], classes?: UIClassesSpec): SVGPolygonElement {
        const pol = newElem('polygon', classes);
        if(typeof points !== 'string')
            points = points.join(' ');
        pol.setAttribute('points', points);
        return pol;
    }

    export function POLYLINE(points: string | number[], classes?: UIClassesSpec): SVGPolylineElement {
        const pol = newElem('polyline', classes);
        if(typeof points !== 'string')
            points = points.join(' ');
        pol.setAttribute('points', points);
        return pol;
    }

    export function ARC(cx: number, cy: number, r: number, start: number, end: number, classes?: UIClassesSpec): SVGElement {
        if(end - start >= 360) {
            return CIRCLE(cx, cy, r, classes);
        }
        const arc = newElem('path', classes);
        const longest = (end - start) >= 180 ? 1 : 0
        start = start * Math.PI / 180;
        end = end * Math.PI / 180;
        const sx = cx + r * Math.sin(start);
        const sy = cy - r * Math.cos(start);
        const ex = cx + r * Math.sin(end);
        const ey = cy - r * Math.cos(end);
        arc.setAttribute('d', `M${sx},${sy}A${r},${r} 0 ${longest},1 ${ex},${ey}`);
        return arc;
    }

    export function STOP(color: string, offset: number) {
        const stop = newElem('stop');
        stop.setAttribute('stop-color', color);
        stop.setAttribute('offset', offset as any);
        return stop;
    }
}
